module.exports = "/images/4ef12ff91e76087f3e207fbb0698bb63.png";